import ApiHelper from "./ApiHelper"
export const BotMessageApi = {
  
    GetBotMessageByUserId: async (payload) => {
        // {chatId:string,messageId:number}
        const { date, lastDate } = payload
        const url = encodeURI(`/bot/getTelebotMessages?date=${date}&lastDate=${lastDate}`)
        const result = await ApiHelper.get(url)
        return result.data
    }
}